import { Box } from '@mui/material';

export const DrawerCard = ({
  children,
}: {
  children: React.ReactNode;
  size?: 'regular' | 'large';
}) => {
  return (
    <Box pb={4} display="flex" flexDirection="column" gap={1}>
      {children}
    </Box>
  );
};
